var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4457_48049)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4457_48049",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.01953 7.26978H8.98953C9.26953 7.26978 9.48953 7.04978 9.48953 6.76978C9.48953 6.48978 9.26953 6.26978 8.98953 6.26978H1.01953C0.739531 6.26978 0.519531 6.48978 0.519531 6.76978C0.519531 7.04978 0.739531 7.26978 1.01953 7.26978Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.01953 7.26978H8.98953C9.26953 7.26978 9.48953 7.04978 9.48953 6.76978C9.48953 6.48978 9.26953 6.26978 8.98953 6.26978H1.01953C0.739531 6.26978 0.519531 6.48978 0.519531 6.76978C0.519531 7.04978 0.739531 7.26978 1.01953 7.26978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01953 8.26978H8.98953V6.26978H1.01953V8.26978ZM8.98953 8.26978C9.82182 8.26978 10.4895 7.60206 10.4895 6.76978H8.48953C8.48953 6.49749 8.71725 6.26978 8.98953 6.26978V8.26978ZM10.4895 6.76978C10.4895 5.93749 9.82182 5.26978 8.98953 5.26978V7.26978C8.71725 7.26978 8.48953 7.04206 8.48953 6.76978H10.4895ZM8.98953 5.26978H1.01953V7.26978H8.98953V5.26978ZM1.01953 5.26978C0.187247 5.26978 -0.480469 5.93749 -0.480469 6.76978H1.51953C1.51953 7.04206 1.29182 7.26978 1.01953 7.26978V5.26978ZM-0.480469 6.76978C-0.480469 7.60206 0.187247 8.26978 1.01953 8.26978V6.26978C1.29182 6.26978 1.51953 6.49749 1.51953 6.76978H-0.480469Z",
    fill: "white",
    mask: "url(#path-1-inside-1_4457_48049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01953 10.7397L4.99953 10.7397H1.01953V10.7397Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01953 3.26978H8.98953C9.26953 3.26978 9.48953 3.04978 9.48953 2.76978C9.48953 2.48978 9.26953 2.26978 8.98953 2.26978H1.01953C0.739531 2.26978 0.519531 2.48978 0.519531 2.76978C0.519531 3.04978 0.739531 3.26978 1.01953 3.26978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9893 10.2598H12.5093V6.76978C12.5093 6.48978 12.2893 6.26978 12.0093 6.26978C11.7293 6.26978 11.5093 6.48978 11.5093 6.76978V10.2598H8.0293C7.7493 10.2598 7.5293 10.4798 7.5293 10.7598C7.5293 11.0398 7.7493 11.2598 8.0293 11.2598H11.5093V14.7498C11.5093 15.0298 11.7293 15.2498 12.0093 15.2498C12.2893 15.2498 12.5093 15.0298 12.5093 14.7498V11.2598H15.9893C16.2693 11.2598 16.4893 11.0398 16.4893 10.7598C16.4893 10.4798 16.2693 10.2598 15.9893 10.2598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4457_48049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.503906 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToList);
export default __webpack_public_path__ + "static/media/add-to-list.ebb93adcf6fdc3e56b814835285cea01.svg";
export { ForwardRef as ReactComponent };